import { render, staticRenderFns } from "./RuleNotificationSpec.vue?vue&type=template&id=4409bd50&scoped=true&"
import script from "./RuleNotificationSpec.vue?vue&type=script&lang=ts&"
export * from "./RuleNotificationSpec.vue?vue&type=script&lang=ts&"
import style0 from "./RuleNotificationSpec.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RuleNotificationSpec.vue?vue&type=style&index=1&id=4409bd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4409bd50",
  null
  
)

export default component.exports